export function createCustomApiError(message: string, status: number, errorName = 'CartError'): Error {
  const error = new Error(message);
  error.name = errorName;
  (error as any).response = {
    status,
    data: { message },
  };
  return error;
}
